// extracted by mini-css-extract-plugin
export default {"jobBreadcrumb":"_3IXWAM2z","title":"_3eLGOmt4","titleLoggedIn":"_3xy9-j3W","titleWithBreadcrumb":"_1jmlk0Oq","description":"_2bCGm3g7"};